import { render, staticRenderFns } from "./KpiSoporteTecnicoGerencia.vue?vue&type=template&id=99a5c4cc&"
import script from "./KpiSoporteTecnicoGerencia.vue?vue&type=script&lang=js&"
export * from "./KpiSoporteTecnicoGerencia.vue?vue&type=script&lang=js&"
import style0 from "./KpiSoporteTecnicoGerencia.vue?vue&type=style&index=0&id=99a5c4cc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports